import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-detail-header-info',
  template: `<div *ngIf="editable; else notEditableMode" class="flex flex-col items-start gap-1 md:flex-row">
      <span class="pt-2-75 leading-none font-medium">{{ title }}</span>
      <span class="w-full">
        <app-inplace
          [disabled]="disabled"
          (setValue)="setDescriptionValue.emit(newDescriptionValue)"
          (resetValue)="newDescriptionValue = oldDescriptionValue">
          <ng-template #viewMode>
            <span *ngIf="newDescriptionValue; else descriptionPlaceholder" class="text-gray-700" role="presentation">{{
              newDescriptionValue
            }}</span>
            <ng-template #descriptionPlaceholder>
              <span class="text-gray-700 italic">{{
                'search.filters.placeholder.text' | translate: { '0': title }
              }}</span>
            </ng-template>
          </ng-template>
          <ng-template #editMode>
            <textarea pTextarea rows="10" class="w-full" [(ngModel)]="newDescriptionValue" role="input"></textarea>
          </ng-template>
        </app-inplace>
      </span>
    </div>

    <ng-template #notEditableMode>
      <div class="flex flex-col items-start gap-x-4 gap-y-1 md:flex-row">
        <span class="min-w-max">{{ title }}</span>
        <span class="w-full text-gray-700"> {{ newDescriptionValue }}</span>
      </div>
    </ng-template>`,
  standalone: false
})
export class DetailHeaderInfoComponent {
  @Input() title: string;
  @Input() set description(value: string) {
    this.oldDescriptionValue = value;
    this.newDescriptionValue = value;
  }
  @Input() disabled: boolean;
  @Input() editable: boolean = true;

  @Output() setDescriptionValue = new EventEmitter<string>();

  public oldDescriptionValue: string;
  public newDescriptionValue: string;
}
